






























































































import { SpecOutDetailsModule } from "@/store/modules/specOutDetails";
import { Component, Vue } from "vue-property-decorator";
import GiganautVue from "@/components/Shared/GiganautVue";
import SpecOutStatus from "@/models/SpecOuts/SpecOutStatus";
import SpecOutGeneralDetailsEdit from "@/components/SpecOuts/SpecOutGeneralDetailsEdit.vue";
import SpecOutEmailDetailsEdit from "@/components/SpecOuts/SpecOutEmailDetailsEdit.vue";

@Component({
  name: "SpecOutDetails",
  components: { SpecOutGeneralDetailsEdit, SpecOutEmailDetailsEdit },
})
export default class extends GiganautVue {

  specOutStatus = SpecOutStatus;

  get specOut() {
    return SpecOutDetailsModule.currentSpecOut;
  }

  get isDraft() {
    return this.specOut.status === SpecOutStatus.Draft;
  }
}
